import { useEffect } from "react";

/**
 * 监听页面可见性（OS 前后台切换、浏览器标签激活）。
 * 切回前台后：立即 + 延迟各取一次最新消息，并恢复滚动位置。
 *
 * @param {boolean}  active
 * @param {function} updateMsg          - 拉取最新消息
 * @param {object}   isAtBottomRef      - 是否在底部
 * @param {object}   shouldScrollBottom - 滚动控制 ref
 * @param {object}   listRef            - 消息列表 DOM ref
 */
export default function useMessageSyncOnForeground({ active, updateMsg, isAtBottomRef, shouldScrollBottom, listRef }) {
  useEffect(() => {
    let retryTimer1 = null;
    let retryTimer2 = null;

    const handleVisible = () => {
      if (!active) return;
      requestAnimationFrame(() => {
        const el = listRef.current;
        if (el && isAtBottomRef.current) el.scrollTop = el.scrollHeight;
      });
      if (isAtBottomRef.current) shouldScrollBottom.current = true;
      try { updateMsg(); } catch (e) {}

      clearTimeout(retryTimer1);
      clearTimeout(retryTimer2);
      retryTimer1 = setTimeout(() => {
        if (!active) return;
        if (isAtBottomRef.current) {
          shouldScrollBottom.current = true;
          const el = listRef.current;
          if (el) el.scrollTop = el.scrollHeight;
        }
        try { updateMsg(); } catch (e) {}
      }, 600);
      retryTimer2 = setTimeout(() => {
        if (!active) return;
        if (isAtBottomRef.current) {
          shouldScrollBottom.current = true;
          const el = listRef.current;
          if (el) el.scrollTop = el.scrollHeight;
        }
        try { updateMsg(); } catch (e) {}
      }, 1800);
    };

    const isHidden = () =>
      typeof document.hidden !== "undefined" ? document.hidden
      : typeof document.webkitHidden !== "undefined" ? document.webkitHidden
      : false;

    const visibilityEvent =
      typeof document.hidden !== "undefined" ? "visibilitychange"
      : typeof document.webkitHidden !== "undefined" ? "webkitvisibilitychange"
      : null;

    const visibilityHandler = () => { if (!isHidden()) handleVisible(); };

    if (visibilityEvent) {
      document.addEventListener(visibilityEvent, visibilityHandler, false);
    } else {
      window.addEventListener("focus",    handleVisible);
      window.addEventListener("pageshow", handleVisible);
    }
    if (document.addEventListener) document.addEventListener("resume", handleVisible, false);

    return () => {
      clearTimeout(retryTimer1);
      clearTimeout(retryTimer2);
      if (visibilityEvent) {
        document.removeEventListener(visibilityEvent, visibilityHandler, false);
      } else {
        window.removeEventListener("focus",    handleVisible);
        window.removeEventListener("pageshow", handleVisible);
      }
      if (document.removeEventListener) document.removeEventListener("resume", handleVisible, false);
    };
  }, [active, updateMsg, isAtBottomRef, shouldScrollBottom, listRef]);
}
